export default __webpack_public_path__ + "static/media/pin.297e62bd.svg";